import performanceLabs from "public/pocCloud/performance-labs.jpg";
import { ListWithLabel } from "@/components/list";

export const INTRO_CONSTANTS = {
  title: "Performance Labs & OEM Test Labs — Precision Testing, Real-World Assurance",
  description: [
    "Before deployment, performance matters. Whether it’s fine-tuning software, validating network configurations, or testing OEM components, OneMind’s Performance Labs provide a focused environment to uncover issues, optimize outcomes, and ensure systems meet real-world demands.",
    "For manufacturers, our OEM Test Labs offer controlled, purpose-built infrastructure to verify that hardware and systems meet the highest standards of compatibility, compliance, and reliability—long before they reach production.",
  ],
  children: (
    <ListWithLabel
      points={[
        {
          label: "Replicate Production Environments",
          text: "Simulate realistic operating conditions to test performance, scalability, and interoperability.",
        },
        {
          label: "Optimize Across the Stack",
          text: "Adjust and refine applications, networks, and hardware for maximum efficiency and reliability.",
        },
        {
          label: "Minimize Risk Before Deployment",
          text: "Identify potential issues early, validate performance metrics, and ensure a smooth rollout.",
        },
      ]}
    />
  ),
  image: performanceLabs,
};
